<script>
import { periodicTasksClockedScheduleMethods } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ClockedScheduleForm',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      form: {
        url: null,
        clocked_time: null,
      },
    }
  },
  validations: {
    form: {
      clocked_time: {
        required,
      },
    },
  },
  computed: {},

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.action = 'update'
      context.form = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...periodicTasksClockedScheduleMethods,

    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchPeriodicTasksClockedScheduleDetail(
          context.form.url
        )
        return promise
          .then((data) => {
            context.form = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      if (context.$v.form.$invalid) {
        context.$generate_toast(
          context,
          'error',
          'Por favor llene todos los campos requeridos'
        )
        return
      }
      const promise = context.createUpdatePeriodicTasksClockedSchedule(
        context.form
      )
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `Programación ${
              context.action == 'create' ? 'creada' : 'actualizada'
            } correctamente`
          )
          setTimeout(() => {
            context.oncomplete(data.url)
            context.submitting = false
          }, 3000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="action === 'create' ? $t('basic.create') : $t('basic.edit')"
    :size="action === 'create' ? 'md' : 'md'"
    @hidden="oncancel"
    @ok.prevent="submit"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <b-form id="form">
            <form-wrapper :validator="$v.form">
              <div>
                <form-summary />
              </div>
              <b-form-group name="clocked_time" label="Fecha">
                <VueCtkDateTimePicker
                  v-model="form.clocked_time"
                  format="YYYY-MM-DDTHH:mm:ss.sssZ"
                />
              </b-form-group>
            </form-wrapper>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        {{ $t('basic.cancel') }}
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> Guardando </span>
        <span v-else>
          <i class="fad fa-floppy-disk"></i>
          {{ $t('basic.save') }}
        </span>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss">
</style>